import { NgModule, LOCALE_ID, APP_INITIALIZER, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { MatDialogModule } from '@angular/material/dialog';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { registerLocaleData, DatePipe } from "@angular/common";
import localeEs from "@angular/common/locales/es";
import { LayoutModule } from './core/layout/layout.module';
import { Interceptor } from './core/interceptors/interceptor.interceptor';
import { AuthService, socialAuthServiceConfigFactory } from './core/services/auth.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { MAT_DATE_LOCALE } from "@angular/material/core";

import { SocialLoginModule } from '@abacritt/angularx-social-login';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { ConfigEnviromentService } from './core/services/configEnviroment.service';

registerLocaleData(localeEs);
// Función de inicialización para cargar la configuración antes del bootstrap
export function initializeApp(configService: ConfigEnviromentService) {
  return () => configService.loadConfig();
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MatDialogModule,
    MatMomentDateModule,
    LayoutModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: false
    }),
    SocialLoginModule
  ],
  providers: [
    DatePipe,
    { provide: LOCALE_ID, useValue: "es" },
    { provide: MAT_DATE_LOCALE, useValue: "es-ES" },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Interceptor,
      multi: true,
    },
    /*{
      provide: 'SocialAuthServiceConfig',
      useValue: socialAuthServiceConfigFactory(),
    },*/
    AuthService,
    ConfigEnviromentService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [ConfigEnviromentService],
      multi: true
    },
    {
      provide: 'SocialAuthServiceConfig',
      useFactory: socialAuthServiceConfigFactory,
      deps: [ConfigEnviromentService], // Se añade la dependencia del servicio de configuración
      multi: false
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
